// LoadingSpinner.jsx
import React from 'react';

/**
 * Loading spinner component to show during asynchronous operations
 * @param {Object} props
 * @param {string} [props.message='Loading...'] - Message to display below the spinner
 * @param {string} [props.size='medium'] - Size of the spinner (small, medium, large)
 */
const LoadingSpinner = ({ message = 'Loading...', size = 'medium' }) => {
  const spinnerSizeClass = {
    small: 'spinner-small',
    medium: 'spinner-medium',
    large: 'spinner-large'
  }[size] || 'spinner-medium';

  return (
    <div className="loading-spinner-container">
      <div className={`loading-spinner ${spinnerSizeClass}`}>
        <div className="spinner-circle"></div>
      </div>
      {message && <p className="loading-message">{message}</p>}
    </div>
  );
};

export default LoadingSpinner;